import React from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";

const CandidatosDelete = ({
  onClose,
  open,
  mostrarAlertaTemporal,
  obtenerCandidatos,
  id_candidato,
}) => {
  const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

  const SeleccionarCandidatoUpdate = async () => {
    try {
      const response = await fetch(`${UrlApi}/SP_candidatos/${id_candidato}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ estado: null }),
      });

      if (!response.ok) {
        mostrarAlertaTemporal(
          "Hubo un error al eliminar el candidato",
          "error"
        );
      }
      mostrarAlertaTemporal(
        "El candidato ha sido eliminado correctamente",
        "success"
      );

      await obtenerCandidatos();
    } catch (error) {
      console.error("hubo un error al mandar la solicutud", error);
      mostrarAlertaTemporal("Server was busy, Try again later", "error");
    }
    logEventos(
      "eliminando/ocultando candidato",
      "Candidatos",
      "Selecciono un candidatos para la ocultarlo de la lista",
      localStorage.getItem("user")
    );

    onClose();
  };
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      TransitionComponent={Transition}
    >
      <Box justifyContent="center" backgroundColor="#1F618D">
        <DialogTitle>
          <Box component="div">
            <Typography
              variant="h6"
              align="center"
              color="#ffffff"
              sx={{ fontWeight: "bold" }}
            >
              Eliminar candidato
            </Typography>
          </Box>
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText textAlign={"center"}>
          ¿Esta seguro que quiere eliminar el candidato?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Grid
          container
          direction="row"
          justifyContent="space-around"
          alignItems="center"
        >
          <Button
            variant="contained"
            onClick={onClose}
            style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
          >
            Volver
          </Button>
          <Button
            style={{ color: "#ffffff" }}
            type="submit"
            onClick={SeleccionarCandidatoUpdate}
            variant="contained"
            color="primary"
          >
            Confirmar
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default CandidatosDelete;
